import ContentBox from '@root/components/v2/content/ContentBox';
import { CARD_TITLE_STYLE } from '../../Dashboard/cardUtils';

// A card of the Findings overlay: the same ContentBox header as the vulnerabilities dashboard cards
// (icon + title), with the body padded below it.
const DetailSection = ({ title, icon: Icon, iconColor, children }) => (
  <ContentBox
    title={
      <span className="FindingDetails__CardTitle">
        {Icon && <Icon size={16} color={iconColor} aria-hidden="true" />}
        {title}
      </span>
    }
    titleContainerStyle={CARD_TITLE_STYLE}
    containerClassName="border-box-no-pad"
    paddingMode="content">
    <div className="FindingDetails__CardBody">{children}</div>
  </ContentBox>
);

export default DetailSection;
